import { useEffect } from "react"

interface SlideDrawerProps {
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
    variant?: 'drawer' | 'modal'
}

export const SlideDrawer: React.FC<SlideDrawerProps> = ({ isOpen, onClose, children, variant = 'drawer' }) => {
    useEffect(() => {
        if (!isOpen) return
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose()
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [isOpen, onClose])

    return (
        <div className={`slide-drawer-overlay ${variant === 'modal' ? 'slide-drawer-overlay--modal' : ''} ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div className={`slide-drawer ${variant === 'modal' ? 'slide-drawer--modal' : ''} ${isOpen ? 'open' : ''}`} onClick={e => e.stopPropagation()}>
                <button className="slide-drawer-close" onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <div className="slide-drawer-content">
                    {children}
                </div>
            </div>
        </div>
    )
}
